export const BackEndSvg = () => (
  <svg
    enableBackground='new 0 0 128 128'
    id='Layer_1'
    version='1.1'
    viewBox='0 0 128 128'
    xmlSpace='preserve'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <rect fill='#2BACE2' height='2' width='31.553' x='48.563' y='28.147' />
      <rect fill='#2BACE2' height='2' width='31.553' x='48.563' y='38.154' />
      <rect fill='#2BACE2' height='2' width='31.553' x='48.563' y='48.163' />
      <path
        d='M110.559,28.147H87.092v-9.96H40.505v9.96H17.441v71.407h23.063v10.258h46.587V99.555h23.467V28.147z    M19.441,97.555V30.147h21.063v7.81H23.896v2h16.607v8.007H23.896v2h16.607v8.008H23.896v2h16.607v37.583H19.441z M85.092,107.813   H42.505v-8.258h0.052v-2h-0.052V20.188h42.587V107.813z M108.559,97.555H87.092V59.972h17.012v-2H87.092v-8.008h17.012v-2H87.092   v-8.007h17.012v-2H87.092v-7.81h21.467V97.555z'
        fill='#2BACE2'
      />
      <path
        d='M80.115,57.972h-31.75v42.466h31.75V57.972z M78.115,98.438h-27.75V59.972h27.75V98.438z'
        fill='#2BACE2'
      />
    </g>
  </svg>
)
